import { useNavigate, useLocation } from 'react-router-dom';

import { useMasterclass } from '@/contexts/MasterclassContext';
import authConfig from '@/modules/auth/config/auth-config.json';
import { useAuth } from '@/modules/auth/hooks/useAuth';
import { getBreadcrumbs } from '@/utils/breadcrumbs';

import { UserProfile, AppHeaderConfig, Breadcrumb } from '../types';

export const useAppHeader = (
  userProfile: UserProfile | null | undefined,
  config: AppHeaderConfig
) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedCase } = useMasterclass();
  const { handleSignOut } = useAuth(authConfig);

  // Generate breadcrumbs based on current route
  const breadcrumbs: Breadcrumb[] = getBreadcrumbs(
    location.pathname,
    selectedCase,
    config.breadcrumb
  );

  // Get user initials for avatar fallback
  const getInitials = (): string => {
    if (userProfile?.full_name) {
      return userProfile.full_name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
    }
    return userProfile?.email?.[0]?.toUpperCase() || 'U';
  };

  // Get display name for user menu
  const getDisplayName = (): string => {
    return userProfile?.full_name || userProfile?.email?.split('@')[0] || 'Utilisateur';
  };

  // Navigate to home
  const navigateHome = () => {
    if (config.logo.clickable) {
      navigate(config.logo.homeRoute);
    }
  };

  return {
    breadcrumbs,
    displayName: getDisplayName(),
    initials: getInitials(),
    handleSignOut,
    navigateHome,
    navigate,
  };
};
